import React from 'react';
import { GelRowLayout, GelColumnLayout, GelContainerLite } from '@tal-gel/components';
import { has, isEmpty } from 'lodash';
import { defaultH3Text, boldLabel, defaultFontText, subSectionTitle, subSectionTopLine, subSectionMinHeight } from '../Shared/Styles';

export default function Beneficiaries(props) {
    let beneficiaries;

    if (!props.beneficiaries || isEmpty(props.beneficiaries)) {
        beneficiaries = [0];
    } else {
        beneficiaries = props.beneficiaries;
    }

    return (
        <GelContainerLite style={subSectionMinHeight}>
            <hr style={subSectionTopLine} />
            <GelRowLayout gutter="medium" style={subSectionTitle}>
                <h3 style={defaultH3Text} data-testid="beneficiariesLabel">Beneficiaries</h3>
            </GelRowLayout>
            {beneficiaries.map((beneficiary, index) =>
                <div key={index}>
                    {(index !== 0) ? <hr /> : <span></span>}
                    <GelRowLayout gutter="medium" style={defaultFontText}>
                        <GelColumnLayout distribution="1/2 1/2">
                            <GelRowLayout gutter="small">
                                <GelColumnLayout distribution="1/2 1/2">
                                    <div style={boldLabel}>Beneficiary Name</div>
                                    {(has(beneficiary, 'relationship') && beneficiary.relationship.trim() !== ""
                                        && beneficiary.relationship !== "Unknown"
                                        && beneficiary.relationship !== null) ?
                                        <div style={boldLabel}>Relationship</div> : ""}
                                </GelColumnLayout>
                            </GelRowLayout>
                            <GelRowLayout gutter="small">
                                <GelColumnLayout distribution="1/2 1/2">
                                    {(has(beneficiary, 'beneficiaryAddress'))
                                        && (beneficiary.beneficiaryAddress.trim() !== "")
                                        && (beneficiary.beneficiaryAddress !== null) ?
                                        <div style={boldLabel}>Beneficiary Address</div> : ""}
                                    <div style={boldLabel}>Beneficiary Percentage</div>
                                </GelColumnLayout>
                            </GelRowLayout>
                        </GelColumnLayout>
                    </GelRowLayout>

                    <GelRowLayout gutter="medium" style={defaultFontText}>
                        <GelColumnLayout distribution="1/2 1/2">
                            <GelRowLayout gutter="small">
                                <GelColumnLayout distribution="1/2 1/2">
                                    <div data-testid="beneficiaryName">
                                        {(has(beneficiary, 'beneficiaryName')) ? beneficiary.beneficiaryName : ""}
                                    </div>
                                    {has(beneficiary, 'relationship') &&  (
                                                beneficiary.relationship.trim() !== "" &&
                                                beneficiary.relationship !== "Unknown" &&
                                                beneficiary.relationship !== null)
                                            ? ( <div data-testid="relationship">{beneficiary.relationship}</div>)
                                            : ""}
                                </GelColumnLayout>
                            </GelRowLayout>
                            <GelRowLayout gutter="small">
                                <GelColumnLayout distribution="1/2 1/2">
                                    {(has(beneficiary, 'beneficiaryAddress')
                                        && beneficiary.beneficiaryAddress.trim() !== ""
                                        && beneficiary.beneficiaryAddress !== null) ?
                                        <div data-testid="beneficiaryAddress">{(has(beneficiary, 'beneficiaryAddress')) ? beneficiary.beneficiaryAddress : ""}</div> : ""}
                                    <div data-testid="benefitPercent">{(has(beneficiary, 'benefitPercent')) ? beneficiary.benefitPercent : ""}</div>
                                </GelColumnLayout>
                            </GelRowLayout>
                        </GelColumnLayout>
                    </GelRowLayout>
                </div>
            )}

        </GelContainerLite>
    );

}